import Image from 'next/future/image';
import Link from 'next/link';
import Slider from '../slider/Slider';
import { LEADERS, leadersBreakpoints } from './constants';
import { LeaderT } from './types';
import reebeloDarkLogo from '@/public/images/about/reebelo-dark.svg';

const Card = ({ leader }: { leader: LeaderT }) => (
  <div
    className="flex h-full flex-col justify-between rounded border text-center"
    key={leader.name}
  >
    <div className="flex flex-col items-center justify-center p-3 md:p-5">
      <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-teal-500/50 sm:h-24 sm:w-24 lg:h-28 lg:w-28">
        <div className="h-full w-full overflow-hidden rounded-full">
          <div className="h-full w-full">
            <Image
              src={leader.image}
              alt={leader.name}
              width={300}
              height={300}
              className="h-full w-full object-contain object-bottom"
            />
          </div>
        </div>
        <div className="absolute bottom-1.5 right-1.5 h-7 w-7">
          <Image
            src={reebeloDarkLogo}
            alt="Reebelo"
            width={50}
            height={50}
            className="h-full w-full"
          />
        </div>
      </div>
      <h4 className="mt-5 text-lg font-bold">{leader.name}</h4>
      <div className="mt-1 flex h-8 items-center justify-center rounded border border-gray-700 px-2 text-xs">
        {leader.postion}
      </div>
      <p className="mt-5 text-sm">{leader.intro}</p>
    </div>
    <div className="flex w-full flex-col items-center gap-3 bg-gray-200 p-3 text-center xxs:flex-row xxs:text-left md:p-5">
      <div className="h-12 w-12 shrink-0 md:h-16 md:w-16">
        <Image
          src={leader.topPick.image}
          alt={leader.topPick.title}
          width={300}
          height={300}
          className="h-full w-full object-contain mix-blend-multiply"
        />
      </div>
      <div className="text-sm">
        <span className="inline xxs:block">Top refurbished pick: </span>
        <Link href={leader.topPick.link} passHref>
          <a
            className="text-[#0D6EFD] underline underline-offset-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            {leader.topPick.title}
          </a>
        </Link>
      </div>
    </div>
  </div>
);

const Leaders = () => (
  <div className="reebelo-container  py-10 sm:py-16">
    <div className="relative">
      <Slider breakpoints={leadersBreakpoints}>
        {LEADERS.map((leader) => (
          <Card leader={leader} />
        ))}
      </Slider>
    </div>
  </div>
);

export default Leaders;
